<template>
    <b-form ref="form" :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}"
            :initial-data="initialData" :save-params="{course}">
        <div class="row">
            <div class="col-12">
                <validated-input label="Charge Type" v-model="model.charge_type"
                                 :rules="{required: true}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-input type="number" label="Days" v-model="model.days"
                                 :rules="{required: true, min_value:1}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-input label="Rate" v-model="model.rate"
                                 :rules="{required: true, min_value:1}" :disabled="loading" step="0.01"/>
            </div>
            <div class="col-12">
                <btn class="trn" text="Update" loading-text="Updating..." size="sm"
                     :disabled="loading"
                     :loading="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';

export default {
    name: 'EditCourseCharge',

    props: {
        checkIfPublished: { type: Boolean, default: false },
        initialData: { type: Object },
        course: { type: String }
    },

    data () {
        return {
            addUrl: urls.admin.course.detailsUrl.charge.addEdit
        };
    },

    methods: {
        clearFile (file) {
            this.initialData.banner_image = '';
        },
        viewFile (file) {
            window.open(file);
        },
        formSuccess (response) {
            this.$notify('Successfully Updated Item..!', 'Success',
                {
                    type: 'success'
                }
            );
            this.$emit('success', response);
        }
    }
};
</script>

<style scoped>

</style>
